import React from "react";
import Modal from "react-modal";
import { PrimaryActionButton } from "../PrimaryActionButton/PrimaryActionButton";

// A PrimaryActionButton that opens its children in a modal. Page scroll is
// locked while the modal is open and restored to what it was before, so a
// modal opened from the open mobile menu leaves the menu's scroll lock alone.
export function ModalButton(props) {
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const previousOverflow = React.useRef("");

    const openModal = () => {
        previousOverflow.current = document.body.style.overflow;
        setModalIsOpen(true);
        document.body.style.overflow = "hidden";
    };

    const closeModal = () => {
        setModalIsOpen(false);
        document.body.style.overflow = previousOverflow.current;
    };

    return (
        <div className={props.wrapperClassName ?? "flex h-full w-full"}>
            <PrimaryActionButton
                label={props.label}
                onClick={openModal}
                className={props.className}
            />
            <Modal
                className="bg-white h-auto max-h-[80%] min-w-2/5 max-w-[90%] rounded-3xl overflow-y-auto overflow-x-hidden md:max-w-screen-md"
                overlayClassName="overlay"
                appElement={document.getElementById("root") || undefined}
                contentLabel={props.contentLabel ?? props.label}
                closeTimeoutMS={100}
                shouldCloseOnOverlayClick={true}
                onRequestClose={() => closeModal()}
                isOpen={modalIsOpen}
            >
                {props.children}
            </Modal>
        </div>
    );
}
